import { cn } from '@/common/utilities.ts'
import { ChildrenProp } from '@/common/types_and_interfaces.ts'

export const WizardBodyContainer = ({
  className,
  children,
}: { className?: string } & ChildrenProp) => {
  return (
    <div className={cn('w-full px-4 flex-grow flex flex-col', className)}>
      {children}
    </div>
  )
}
